
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IEmailViewModel } from '@/models/fixedops/partsales';
import { IDialogOption } from '@/models/dialog';
import { Base } from '../common/base';
import {partSalesService} from '@/shared';

@Component({
    computed: {
        buttonType: {
            get() {
                if (this.email.customer && this.email.self) {
                    return 'both';
                } else {
                    if (this.email.customer) {
                        return 'customer';
                    } else {
                        return 'self';
                    }
                }
            },
        },
    },
    components: {
        AppDialog: () => import('../common/app.dialog.vue'),
    },
    watch: {
        isDialogOpen(newVal) {
            this.emailDialog.model = newVal;
        },
    },
    props: ['model', 'isDialogOpen'],
})
export default class PartSaleEmailSendComponent extends Base {
    public model: IEmailViewModel;
    // public partSalesService: PartSalesService;
    public invoiceNumber: string;
    public email: any = {
        self: false,
        customer: false,
        from: '',
        froms: [],
    };
    public buttonType;

    public emailDialog: IDialogOption = {
        width: 700,
        title: this.$parent.$t('partSalesSendEmail.confirmText') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-paper-plane', text: this.$parent.$t('partSalesSendEmail.send') as string, disable: false },
        onAction: (): void => {
            this.sendEmail();
        },
        onClose: (): void => {
            this.close();
        },
        loading: false,
    };

    public mounted(): void {
        // this.partSalesService = new PartSalesService();
        this.email.froms.push(this.userEmail);
    }

    public async sendEmail(): Promise<void> {
        if (!this.email.customer && !this.email.self) {
            this.showAlert(false, this.$parent.$t('partSalesSendEmail.selectCustomerOrSelf'));
            return;
        }

        if (!this.email.from) {
            this.showAlert(false, this.$parent.$t('partSalesSendEmail.selectFromEmail'));
            return;
        }

        try {
            this.emailDialog.loading = true;
            const emailModel = this.model;
            emailModel.buttonType = this.buttonType;
            emailModel.fromEmail = this.email.from;
            await partSalesService.sendEmail(emailModel);
            this.showAlert(true, this.$parent.$t('partSalesSendEmail.partSalesEmailSent'));
        } finally {
            this.emailDialog.loading = false;
            this.close();
        }
    }

    public close(): void {
        this.$emit('onClose');
    }
}
